module.exports = __webpack_public_path__ + "static/media/aps-logo.9ecdc790.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/aps-logo.png
// module id = 1724
// module chunks = 0